<template>
  <div class="ds-empty-state">
    <i class="ds-empty-state__icon" :class="iconClass"></i>
    <div class="ds-empty-state__title">{{ title || defaultTitle }}</div>
    <div class="ds-empty-state__desc" v-if="description">{{ description }}</div>
    <div class="ds-empty-state__action" v-if="$slots.action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
/**
 * DsEmptyState —— 空态展示
 *
 * 统一全站「无数据 / 无权限 / 出错 / 断网」的呈现方式。
 * 状态不只用颜色区分，始终配图形 + 文案。
 *
 * Props:
 *  - type        {String} no-data|no-permission|error|network|search
 *  - title       {String} 主文案
 *  - description {String} 副文案
 *
 * Slots:
 *  - action  动作按钮区（如「重置筛选」）
 */
const DEFAULT_TITLES = {
  'no-data': '暂无数据',
  'no-permission': '暂无访问权限',
  error: '数据加载失败',
  network: '网络连接异常',
  search: '未找到匹配结果'
}

const ICON_MAP = {
  'no-data': 'el-icon-document-remove',
  'no-permission': 'el-icon-lock',
  error: 'el-icon-warning-outline',
  network: 'el-icon-connection',
  search: 'el-icon-search'
}

export default {
  name: 'DsEmptyState',
  props: {
    type: {
      type: String,
      default: 'no-data'
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    defaultTitle () {
      return DEFAULT_TITLES[this.type] || DEFAULT_TITLES['no-data']
    },
    iconClass () {
      return ICON_MAP[this.type] || ICON_MAP['no-data']
    }
  }
}
</script>

<style lang="scss" scoped>
.ds-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--ds-spacing-2xl) var(--ds-spacing-lg);
  text-align: center;

  &__icon {
    font-size: 44px;
    color: var(--ds-gray-300);
    margin-bottom: var(--ds-spacing-md);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-700);
    line-height: 1.5;
  }

  &__desc {
    margin-top: var(--ds-spacing-xs);
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
    line-height: 1.6;
    max-width: 420px;
  }

  &__action {
    margin-top: var(--ds-spacing-md);
  }
}
</style>
